import alt from '../alt';
import csv from 'fast-csv';
import fileDownload from 'react-file-download';

let csvFileUrl = '/assets/data.csv';

class CerseActions {
  loadFileCsv() {
    var request = new XMLHttpRequest();
    request.onreadystatechange = (e) => {
      if (request.readyState !== 4) {
        return;
      }

      if (request.status === 200) {

        //Process CSV
        let articles = [];
        let local = this;
        csv
         .fromString(request.responseText, {headers: true})
         .on("data", function(data){
           articles.push(data);
         })
         .on("end", function(){
           local.csvLoaded({
             articles: articles,
             csvstring: request.responseText
           })
         });
         //End Process CSV
      } else {
        console.warn('error');
      }
    };

    request.open('GET', csvFileUrl);
    request.send();

    return '';
  }

  csvLoaded(info) {
    return info;
  }

  downloadCsv(articles) {
    csv.writeToString(
      articles,
      {headers: true},
      function(err, data){
        fileDownload(data, 'articles.csv');

        window.open(data);
      }
    );

    return articles;
  }

  downloadBib(articles) {
    let body = articles.map(j => j.bibtex).join("\n");
    fileDownload(body, 'articles.bibtex');

    return articles;
  }


  saveFormsContent(newContent) {
    return newContent;
  }
}

export default alt.createActions(CerseActions);



// WEBPACK FOOTER //
// ./src/actions/CerseActions.js